module.exports = __webpack_public_path__ + "c813eb94a991208ecabe7b4b9a273c13.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-24.png
// module id = 2255
// module chunks = 0